import { useState, useEffect } from 'react';

interface DialBackNavProps {
  onJoinBeta: () => void;
}

export default function DialBackNav({ onJoinBeta }: DialBackNavProps) {
  const [scrolled, setScrolled] = useState(false);

  useEffect(() => {
    const onScroll = () => setScrolled(window.scrollY > 40);
    window.addEventListener('scroll', onScroll);
    return () => window.removeEventListener('scroll', onScroll);
  }, []);

  return (
    <nav
      className={`fixed top-0 left-0 right-0 z-[100] flex items-center justify-between px-12 py-5 transition-all duration-300 max-md:px-6 ${
        scrolled ? 'bg-[#0e0d0b] border-b border-white/5' : 'bg-[#0e0d0b] border-b border-white/5'
      }`}
      style={{ fontFamily: "'DM Mono', monospace" }}
    >
      <a href="/dial-back" className="text-[13px] font-medium tracking-[0.08em] text-[#f5f2ec] no-underline whitespace-nowrap">
        <span className="text-[#c8472a]">dial-back</span> · by Delegate
      </a>
      <button
        onClick={onJoinBeta}
        className="text-[12px] font-semibold tracking-[0.1em] uppercase text-[#0e0d0b] bg-[#f5f2ec] px-5 py-2 rounded-sm transition-all duration-200 hover:bg-[#c8472a] hover:text-[#f5f2ec] whitespace-nowrap cursor-pointer"
        style={{ fontFamily: "'Instrument Sans', sans-serif" }}
      >
        Get Early Access
      </button>
    </nav>
  );
}
